module.exports = __webpack_public_path__ + "static/media/Konstantinos-Samaras-Tsakiris.e7316067.png";